
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extension_uninstall",
      function () {
        return require("private-next-pages/extension_uninstall/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extension_uninstall"])
      });
    }
  